export function Field({ label, error, id, hint, children }) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="text-sm font-medium">{label}</label>
      {children}
      {hint && !error && <p className="text-xs text-ink-muted">{hint}</p>}
      {error && <p className="text-sm text-risk" role="alert" data-testid={`field-error-${id}`}>{error}</p>}
    </div>
  );
}
